import {DrawerRecommendation_CollectionsSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/recommendations.types';
import {
  TrackPromotionStoryRecoNormalizer,
  useTrackOriginClick,
} from '@aboutyou/tracking';
import {ContentBlockImageTile, Heading20, Text} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

interface NavigationCollectionProps {
  collection: DrawerRecommendation_CollectionsSection;
  isVisible: boolean;
}

export const NavigationCollection: React.FC<NavigationCollectionProps> = ({
  collection,
  isVisible,
}) => {
  const trackOriginClick = useTrackOriginClick();
  return (
    <CollectionContainer data-testid="collectionContainer">
      <Text as="div" size="px12" color="Grey1">
        {collection.subline}
      </Text>
      <Headline as={Headline}>{collection.headline}</Headline>
      {collection.stories.map((story, index) => {
        const storyContent = (
          <StyledImageTile
            image={{
              ...story.images.landscape,
              aspectRatio: '5:2',
            }}
            content={{
              headlines: {
                alignment: 'center',
                color: 'white',
                size: 'l',
                text: story.headline.default,
              },
            }}
            href={story.path}
            testId={`collectionItemContainer_${index}`}
          />
        );

        const commonProps = {
          'data-testid': `collectionItemContainer_${index}`,
          key: story.path,
        };

        return isVisible ? (
          <TrackPromotionStoryRecoNormalizer
            {...commonProps}
            data={story}
            locationId={'collections_reco'}
            streamPosition={index}
            onClickTracked={trackOriginClick('collections_reco')}
            trackingKey={story.id}
          >
            {storyContent}
          </TrackPromotionStoryRecoNormalizer>
        ) : (
          <div {...commonProps}></div>
        );
      })}
    </CollectionContainer>
  );
};

const CollectionContainer = styled.section`
  padding: 40px 0;
  text-align: center;
`;

const Headline = styled(Heading20)`
  font-weight: 900;
  padding: 4px 0;
  margin-bottom: 30px;
`;

const StyledImageTile = styled(ContentBlockImageTile)`
  padding: 4px 0;
`;
